import {produce} from 'immer';
import { deleteDefinition } from 'state/grid/util';
import {
  SET_DEFINITION,
  SET_DEFINITIONS,
  RECEIVE_DATA,
  REQUEST_DATA,
  DELETE_DEFINITION
} from "./actions";
import {COMMIT_SELECTIONS} from 'state/selections/actions';
import SelectionState from 'state/selections/SelectionState';
import {SummaryType} from '@ls/grouping-service';

const defaultState = {
  definitions: {
    [SelectionState.UNCOMMITTED]: [],
    [SelectionState.COMMITTED]: []
  },
  fetchingData: {
    [SummaryType.ABSOLUTE]: false,
    [SummaryType.RELATIVE]: false,
  },
  data: {
    [SummaryType.ABSOLUTE]: null,
    [SummaryType.RELATIVE]: null
  },
};


export default produce((state = defaultState, action) => {
  switch (action.type) {
    case SET_DEFINITION: {
      const {definition, idx} = action;
      const selectedDefinitions = state.definitions[SelectionState.UNCOMMITTED];
      if (definition === null) {
        selectedDefinitions.splice(idx, 1);
      } else {
        selectedDefinitions[idx] = definition;
      }
      break;
    }
    case DELETE_DEFINITION:
      state.definitions = deleteDefinition(state.definitions, action.payload);
      break;
    case SET_DEFINITIONS: {
      state.definitions[SelectionState.UNCOMMITTED] = action.definitions;
      break;
    }
    case COMMIT_SELECTIONS: {
      state.betaData = defaultState.betaData;
      state.definitions[SelectionState.COMMITTED] = state.definitions[SelectionState.UNCOMMITTED];
      break;
    }
    case REQUEST_DATA: {
      state.fetchingData[action.summary] = true;
      state.data[action.summary] = defaultState.data[action.summary];
      break;
    }
    case RECEIVE_DATA:{
      state.fetchingData[action.summary] = false;
      state.data[action.summary] = action.data;
      break;
    }
    default:
      return state;
  }
});
